module.exports = __webpack_public_path__ + "img/school_principle_intro.67013f37.jpeg";